import { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../../context/UserContext";
import { SettingOption } from "../../../components/SettingOption/setting-option";
import { NotificationsContext } from "../../../context/NotificationsContext";
import { PATCH, UpdateSetting } from "../../../utils/httpUtils";
import { GetLocalSetting, SetLocalSetting } from "../../../utils/genericUtils";
import "./storage-settings.css";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal/confirmation-modal";

const defaultProps = {
  enable_notifications: true,
  enable_sms_notifications: true,
  enable_storage_capacity_notifications: true,
  enable_payment_notifications: true,
};

export default function StorageSettings(props = defaultProps) {
  useEffect(() => {}, []);

  const { user, loginUser } = useContext(UserContext);
  const { pushNotification } = useContext(NotificationsContext);

  const valid = useRef(new Map());

  const [unlock_all_modal_active, setUnlockAllModalActive] = useState(false);

  function UnlockAllObjects() {}

  return (
    <div className="storage-settings-container">
      {/* Actions */}
      {/* <h3>Actions</h3> */}
      {/* <div className="setting-option-divider"></div> */}

      {/* Change PASSWORD */}
      <SettingOption
        id={"unlock-objects"}
        controlType={"button"}
        buttonText=" Unlock All Objects"
        buttonClass={"btn-green-inverted"}
        description="Unlocks all objects in your account with password protection."
        onClick={() => setUnlockAllModalActive(true)}
        showDivider={false}
      />

      <ConfirmationModal
        id="unlock-all-objects-modal"
        animate={true}
        isActive={unlock_all_modal_active}
        header="Unlock All Objects"
        message="This action will unlock all objects within your account"
        confirmText="Unlock All"
        denyText="Cancel"
        confirmClass="btn-green"
        onDeny={() => setUnlockAllModalActive(false)}
        onClickOut={() => setUnlockAllModalActive(false)}
        onConfirm={UnlockAllObjects}
      />
    </div>
  );
}
